import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { getWorkItemStatusColor, WorkItemData } from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'mmx-work-list-status',
  templateUrl: './work-list-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkListStatusComponent {
  @Input()
  public workItems: WorkItemData[]

  public getWorkItemStatusColor = getWorkItemStatusColor

  public constructor(
    private translateService: TranslateService,
  ) {}

  getMatTooltip(workItem: any) {
    const status = this.translateService.instant(`work-item.status.${workItem.status}`)
    const assignedTo = workItem.clinician
      ? `\n${this.translateService.instant('common.assigned-to')}: ${workItem.clinician.name}`
      : ''
    return `${status} ${assignedTo}`
  }
}
